import React from "react";
import { Stack, Heading, HStack, SimpleGrid, Box, Text, VStack } from "@chakra-ui/react";
import Image from "next/image";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import {
  useTextVariants,
  useSectionHeadingVariant,
} from "@/theme/components/useSectionHeading";
import SeparatorImg from "public/openStack/featuresSeparator.png";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComponent = () => {
  const midpoint = Math.ceil(FEATURES_CONSTANTS.length / 2);
  const list1 = FEATURES_CONSTANTS.slice(0, midpoint);
  const list2 = FEATURES_CONSTANTS.slice(midpoint);
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  return (
    <Box>
      <Heading as="h1" variant={HeadingVariant} textAlign={"center"} mb={16}>
        Our Key Features
      </Heading>
      <SimpleGrid
        gridTemplateColumns={{
          base: "1fr",
          sm: "1fr 1fr",
          md: "1fr 0.25fr 1fr",
        }}
        spacing={{ base: 6, sm: 8 }}
        paddingX={"10px"}
        data-cy={"section-features"}
      >
        <VStack align={{ base: "center", sm: "end" }} spacing={10} py={10}>
          {list1.map((item, index) => {
            const { image, title, content } = item;
            return (
              <Stack
                key={index}
                backgroundColor={"#F9FAFC"}
                borderRadius={"8px"}
                p={6}
                spacing={6}
                w={{ base: "auto", sm: "auto", md: "348px" }}
                h={"172px"}
                boxShadow={"lg"}
                borderWidth={"1px"}
                _hover={{ borderColor: "#9ECFFF" }}
              >
                <HStack spacing={4}>
                  {image && (
                    <Image
                      alt={title}
                      src={image}
                      style={{ height: "auto", width: "48px" }}
                    />
                  )}
                  <Heading as="h1" variant={HEADING_VARIANTS.SUBTITLE1} fontWeight={600}>
                    {title}
                  </Heading>
                </HStack>
                <Text variant={TextVariant} color={"text.100"}>
                  {content}
                </Text>
              </Stack>
            );
          })}
        </VStack>
        <Stack
          display={{ base: "none", md: "flex" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Image src={SeparatorImg} alt="Separator" style={{ maxHeight: "900px" }} />
        </Stack>
        <VStack align={{ base: "center", sm: "start" }} spacing={10} py={10}>
          {list2.map((item, index) => {
            const { image, title, content } = item;
            return (
              <Stack
                key={index}
                backgroundColor={"#F9FAFC"}
                borderRadius={"8px"}
                p={6}
                spacing={6}
                w={{ base: "full", sm: "auto", md: "348px" }}
                h={"172px"}
                boxShadow={"lg"}
                borderWidth={"1px"}
                _hover={{ borderColor: "#9ECFFF" }}
              >
                <HStack spacing={4}>
                  {image && (
                    <Image
                      alt={title}
                      src={image}
                      style={{ height: "auto", width: "48px" }}
                    />
                  )}
                  <Heading as="h1" variant={HEADING_VARIANTS.SUBTITLE1} fontWeight={600}>
                    {title}
                  </Heading>
                </HStack>
                <Text variant={TextVariant} color={"text.100"}>
                  {content}
                </Text>
              </Stack>
            );
          })}
        </VStack>
      </SimpleGrid>
    </Box>
  );
};

export default FeaturesComponent;
